// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-actions[data-v-5a9d5069]{align-items:center;display:flex;justify-content:space-between}.language-button[data-v-5a9d5069]{text-transform:uppercase}@media (min-width:75rem){.header-actions[data-v-5a9d5069]{gap:var(--size-2);justify-content:space-evenly}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
